import { render } from "./TermsOfServiceCheckboxField.vue?vue&type=template&id=7c8d07ec"
import script from "./TermsOfServiceCheckboxField.vue?vue&type=script&lang=js"
export * from "./TermsOfServiceCheckboxField.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__